import { z } from 'zod';

export const appSchema = z.object({
  id: z.string(),
  name: z.string(),
  externalId: z.string().nullable(),
  status: z.string(),
  sandboxMode: z.boolean(),
  // 'none' = la app no tiene tenants (resuelto). Se sincroniza de idachu y
  // decide si el backoffice pide tenant o ni lo menciona.
  tenancy: z.enum(['none', 'multi']).default('multi'),
  lastSyncedAt: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
  apiKey: z.string().optional(),
});
export type App = z.infer<typeof appSchema>;

export const appInputSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  sandboxMode: z.boolean().optional(),
});
export type AppInput = z.infer<typeof appInputSchema>;
